import { render, staticRenderFns } from "./AppTableInput.vue?vue&type=template&id=2fc15eb4&scoped=true"
import script from "./AppTableInput.vue?vue&type=script&lang=js"
export * from "./AppTableInput.vue?vue&type=script&lang=js"
import style0 from "./AppTableInput.vue?vue&type=style&index=0&id=2fc15eb4&prod&lang=scss&scoped=true"
import style1 from "./AppTableInput.vue?vue&type=style&index=1&id=2fc15eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc15eb4",
  null
  
)

export default component.exports